import React, { useState, useRef } from 'react'
import InputBase from '@mui/material/InputBase'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { styled } from '@mui/system'
import { Button, Grid } from '@mui/material'

const IconButton = styled(Button)(
  ({ theme }) => `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  color: black;
  border-radius:10px
  `,
)

const InputAdornment = styled('div')`
  margin: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
`

interface InputFieldtProps {
  name: string
  type: 'text' | 'email' | 'password' | 'number' | 'date' | 'time'
  label: string
  id?: string
  value?: any
  placeholder?: string
  onChange?: any
  multiline?: boolean
  rows?: number
  required?: boolean
  autoComplete?: string
  regex?: RegExp
  error?: boolean
  disablePaste?: boolean
  disabled?: boolean
}

const InputField = (props: InputFieldtProps) => {
  const [showPassword, setShowPassword] = useState(false)
  const inputElm = useRef<HTMLInputElement>(null)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const handleClickShowDatePicker = () => {
    inputElm?.current?.showPicker()
  }

  const handleMouseDownDatePicker = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const handleChange = (e: any) => {
    if (props.regex) {
      e.target.value = e.target.value.replace(props.regex, '')
    }
    if (typeof props.onChange === 'function') {
      props.onChange(e)
    }
  }

  let onPaste = undefined
  if (props.disablePaste) {
    onPaste = (e: any) => {
      e.preventDefault()
    }
  }
  return (
    <FormControl variant='standard' fullWidth >
      <Grid container  alignItems='center'>
        <Grid xs={4}>
          <Typography variant='h4' component='p' >
            <label htmlFor={props.id}>
              {props.label}
              {props.required && (
                <Typography variant='subtitle1' color='red' component='span'>
                  &nbsp;*
                </Typography>
              )}
            </label>
          </Typography>
        </Grid>
        <Grid xs={8}>
          <InputBase
          fullWidth
            error={!!props.error}
            name={props.name}
            id={props.id}
            value={props.value}
            placeholder={props.placeholder}
            onChange={handleChange}
            type={showPassword ? 'text' : props.type}
            multiline={!!props.multiline}
            rows={props.rows || 0}
            // required={!!props.required}
            inputRef={inputElm}
            autoComplete={props.autoComplete}
            onPaste={onPaste}
            disabled={!!props.disabled}
            endAdornment={
              props.type === 'password' ? (
                <InputAdornment
                  sx={{
                    position: 'absolute',
                    right: 0,
                    background: 'none',
                    borderRadius: '10px',
                  }}
                >
                  <IconButton
               
                    aria-label='toggle password visibility'
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {!showPassword ? <VisibilityOff htmlColor='white' /> : <Visibility htmlColor='white'  />}
                  </IconButton>
                </InputAdornment>
              ) : props.type === 'date' || props.type === 'time' ? (
                <InputAdornment
                  sx={{
                    position: 'absolute',
                    right: 0,
                    background: '#25272B',
                    borderRadius: '10px',
                  }}
                >
                  <IconButton
                    aria-label='open date picker'
                    onClick={handleClickShowDatePicker}
                    onMouseDown={handleMouseDownDatePicker}
                   
                  >
                    <KeyboardArrowDownIcon  sx={{
                      color:'white'
                    }} />
                  </IconButton>
                </InputAdornment>
              ) : null
            }
            slotProps={{
              input: {
                style: {
                  paddingRight: props.type === 'password' ? '75px' : '21px',
                  // background: props.disabled ? 'lightgray' : '#25272B',
                },
              },
            }}
          />
        </Grid>
      </Grid>
    </FormControl>
  )
}

export default InputField
